module.exports = __webpack_public_path__ + "img/dea-formazione-ico-pnnr.8b558994.svg";